module.exports = __webpack_public_path__ + "static/media/logo_sekolah.a367efc8.png";